export const EPSILON = 0.00001;
export const PI_MUL2 = Math.PI * 2;
export const PI_DIV2 = Math.PI / 2;
export const PI_DIV4 = Math.PI / 4;
export const FACTOR_DEG_TO_RAD = Math.PI / 180;
export const FACTOR_RAD_TO_DEG = 180 / Math.PI;
/**
 * Epsilon equal test.
 */
export function eq(pN1, pN2, pEpsilon = EPSILON) {
    return (Math.abs(pN1 - pN2) <= pEpsilon);
}
/**
 * Epsilon greater equal test.
 */
export function geq(pN1, pN2, pEpsilon = EPSILON) {
    return (pN1 > pN2 || eq(pN1, pN2, pEpsilon));
}
/**
 * Epsilon lesser equal test.
 */
export function leq(pN1, pN2, pEpsilon = EPSILON) {
    return (pN1 < pN2 || eq(pN1, pN2, pEpsilon));
}
export function clamp(pValue, pMin, pMax) {
    return (Math.min(Math.max(pValue, pMin), pMax));
}
export function roundTo(pValue, pDecimals) {
    //use exponential notation to prevent rounding errors (e.g (1.005).toFixed(2) === 1 instead of 1.01)
    //this function is based on: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
    if (pDecimals === 0)
        return (Math.round(pValue));
    if (isNaN(pValue))
        return (NaN);
    //Shift
    let tSubs = pValue.toString().split("e");
    const tShifted = Math.round(Number(tSubs[0] + "e" + (tSubs[1] ? (Number(tSubs[1]) + pDecimals) : pDecimals)));
    //Shift back
    tSubs = tShifted.toString().split("e");
    return Number(tSubs[0] + "e" + (tSubs[1] ? (Number(tSubs[1]) - pDecimals) : -pDecimals));
}
export function radToDeg(pRad) {
    return (pRad * FACTOR_RAD_TO_DEG);
}
export function degToRad(pDeg) {
    return (pDeg * FACTOR_DEG_TO_RAD);
}
